export const shell = {
  header: {
    minHeightMobile: 56,
    minHeightDesktop: 64,
    verticalPaddingMobile: '4px',
    titleGap: '4px',
    actionGap: '4px',
    backButtonSize: 36,
    avatarButtonSize: 34,
    mobileActionsMaxWidth: 180,
  },
  rail: {
    desktopWidth: 72,
    mobileHeight: 60,
    brandHeight: 64,
    navButtonSize: 44,
    indicatorInset: 10,
    indicatorWidth: 4,
    indicatorHeight: 24,
    mobileNavItemMinWidth: 64,
    mobileNavItemMinHeight: 48,
    logoSize: 36,
    wordmarkWidth: 60,
    wordmarkHeight: 48,
  },
  surfaces: {
    // Light shell — AWS Console inspired. Clean white surfaces, minimal dark chrome.
    headerBackground:
      'linear-gradient(105deg, #181614 0%, #201E1B 45%, #262018 100%)',
    railBackground:
      '#FFFFFF',
    railBrandBackground:
      '#FFFFFF',
    // Hero panels: white base with the barest hint of the accent/info color.
    // Think AWS console section headers — clean, light, professional.
    hero: {
      accent:
        '#FFFFFF',
      accentSoft:
        '#FFFFFF',
      info:
        '#FFFFFF',
    },
  },
} as const

export default shell
